// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guide-page{margin:20px}.guide-page .guide-title{font-weight:300}.guide-page .guide-title .guide-lead{font-size:1.5rem}.guide-page .guide-article{margin-bottom:30px;margin-top:30px}.component div.param span.param-name{font-weight:700}.component div.param .param-type{font-size:smaller;margin-left:4px;margin-right:4px}.component div.param span.param-desc{font-style:italic}", ""]);
// Exports
module.exports = exports;
